import httpClient from "utils/httpClient";
import axios from "axios";

const path = "/pre-orders";

export const submitPreOrder = (data, token) => httpClient.post(`${path}/submit`, data, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const sendSms = (data) => httpClient.post(`${path}/sendSms`, data);

export const getProductInfo = (params) =>
  httpClient.get(`${path}/product-info`, { params });

export const getStore = (params) =>
  httpClient.get(`${path}/get-list-store`, { params });

export const getDistrict = (params) =>
  httpClient.get(`${path}/get-district`, { params });

export const getTimeNow = () =>
  httpClient.get(`${path}/get-time-now`);

export const getProvince = (params) =>
  httpClient.get(`${path}/get-province`, { params });

export const createAccount = (data) =>
  httpClient.post(`${path}/create-account`, data);

export const createOrder = (data) =>
  httpClient.post(`${path}/create-order`, data);

export const createOrderDetail = (data) =>
  httpClient.post(`${path}/create-order-detail`, data);

export const checkPhone = (data) =>
  httpClient.post(`${path}/check-phone`, data);

export const getDetailPreOrder = (id) =>
  httpClient.get(`${path}/get-pre-order?preOrderId=${id}`);

export const getPaymented = async () =>
  httpClient.get(`${path}/paymented-pre-order`);

//Coming soon
export const submitVoucher = (data, token) =>
  httpClient.post(`${path}/submit-voucher`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const getVoucher = () => httpClient.get(`${path}/voucher`);

export const submitSubscribe = (data, token) =>
  httpClient.post(`${path}/submit-subscribe`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const getDeposit = () => httpClient.get(`${path}/deposit`); // Lay so tien tra trc

//Lấy discount money từ coupon_code
export const getDiscountMoney = (data) =>
  httpClient.post(`${path}/discount-money`, data);

export const checkIp = () => httpClient.get(`${path}/check-ip`);

export const getDetailPreOrderHashcode = (code) =>
  httpClient.get(`${path}/get-change-product?hashcode=${code}`);

export const updatePreOrder = async (preOrderId, productId, token) => {
  return await axios.post("https://preorder-api.shopdunk.com/pre-orders/update", {
    preOrderId,
    productId
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const submitRefundPreorder = (data, token) => httpClient.post(`${path}/refund`, data, {
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const checkInventorySD = (data, token) => httpClient.post(`${path}/inventory`, data );

export const getStatusPreorderSD = (orderno) => httpClient.get(`${path}/GetStatusDepositReceipt/${orderno}`);

export const confirmWaitOrderSD = (orderno) => httpClient.get(`${path}/ConfirmWait/${orderno}`);

export const loginSD = (data) => httpClient.post(`https://preorder-api.shopdunk.com/auth/login`, data);